import extend from 'extend'
import debug from 'debug'

//如果没有设置日志筛选器，则默认开启 warn , error , info
if (!localStorage.debug)
    debug.enable('*:#warn,*:#error,*:#info')

let factory = function (tag) {
    let info = debug(tag + ":#info");
    let verbose = debug(tag + ":#verbose");
    let warn = debug(tag + ":#warn");
    warn.log = console.warn.bind(console);
    let error = debug(tag + ":#error");
    error.log = console.error.bind(console);

    let retDefault = verbose; // 默认调用为 verbose

    return extend(retDefault, {
        info, warn, error
    })
}



export default factory;